import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

import {NotificationService} from './notification.service';
import {ConfigService} from '../../shared/services';

/** Application-wide error handler that adds a UI notification to the error handling
 * provided by the default Angular ErrorHandler.
 */
@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private notificationsService: NotificationService) {
    super();
  }

  handleError(error: Error | HttpErrorResponse) {
    let displayMessage = 'Ha ocurrido un error.';

    if (!ConfigService.isProduction()) {
      displayMessage += ' Vea la consola para más detalles.';
    }

    this.notificationsService.error(displayMessage);

    super.handleError(error);
  }
}
